import React,{ Fragment, useState } from "react"
import { Button, Table } from "react-bootstrap"
import i18n from "../../../../i18n";
import LabelTranscation from "../../../utilities/Status/transaction";
import { formatCurrency } from "../../../utilities/Class/FormatNumber";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import LabelBilling from "../../../utilities/Status/billing";
const squareStyle = {
    width: "150px",
    height: "150px",
    border: "3px dotted grey",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
  };
export default function DataListRequest(data){
    let arr = data.dataTracking;
    let click = data.updateShow;
    return (
        <div className="card mb-12 mb-xl-8">	
        {arr.data != null ? 
            arr.data.map((item,i)=>{
            return (
                <Fragment key={item.name_customer}>
                    <div className="row" >
                       <h1> {(i+1) + '. ' + item.name_customer}</h1>
                    </div>
                    {item.data_so != null ? 
                        renderDetail(item.data_so,click) : null}
                </Fragment>
            )     
                
            })
            :null
        }	
          
        </div>
    )

    function renderDetail(data,click){
        let arr = data;
        let html = [];
        html.push(
            <Fragment key={'supplier'}>
            <div className="row">
                <table className="table table-responsive table-index " style={{fontSize:'14px'}}>
                    <thead className="bg-success text-white text-center">
                        <tr className="border text-center">
                            <th width={"3%"} className="text-center">{i18n.t("No")}</th>
                            <th width={"15%"} >{i18n.t("Date")}</th>
                            <th width={"15%"}>{i18n.t("No. Purchase Request")}</th>
                            <th width={"15%"}>{i18n.t("Status")}</th>
                            <th width={"15%"}>{i18n.t("Action")}</th>
                        </tr>
                    </thead>
                    <tbody className="border ">
                        {arr!=null?
                            arr.map((item,s)=>{
                                return(
                                    <tr className="border text-center"  key={'supplier'+s}>
                                        <td style={{padding:'5px', textAlign:'center'}}>{(s+1)}</td>
                                        <td style={{padding:'5px', textAlign:'center'}}>{item.date}</td>
                                        <td style={{padding:'5px', textAlign:'center'}}>{item.no_so}</td>
                                        <td style={{padding:'5px', textAlign:'center'}}>
                                            <LabelBilling value={item.status}/>
                                        </td>
                                        <td style={{padding:'5px', textAlign:'center'}}>
                                        <Button
                                            onClick={(e) => {
                                                // this.setState({showData:false,showDataDetail:false});
                                                click(true,item.id);
                                            }}
                                            variant="success"
                                            className="btn btn-xs btn btn-success "
                                            title={i18n.t("View")}
                                            >
                                            <span className="indicator-label"><FontAwesomeIcon icon={faEye} ></FontAwesomeIcon> </span>
                                       
                                            
                                            </Button>
                                        </td>
                                    </tr>)
                            })
                        :null}
                    </tbody>
                </table>
            </div>
            </Fragment>
        );

        return html;
    }
}

 

